import { useEffect } from 'react';
import { MantineProvider } from '@mantine/core';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { AppHeader } from './components/AppHeader';
import { Footer } from './components/Footer';
import Dashboard from './pages/Dashboard';
import BetsList from './pages/BetsList';
import { BetSlipUpload } from './pages/BetSlipUpload';
import { BetSlipReview } from './pages/BetSlipReview';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';

const navigationLinks = [
  { link: '/dashboard', label: 'Dashboard' },
  { link: '/bets', label: 'My Bets' },
  { link: '/upload', label: 'Upload Bet' },
];

function PrivateRoute({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  return children;
}

export default function App() {
  const { user } = useAuth();

  useEffect(() => {
    document.title = 'Betfolio';
  }, []);

  return (
    <MantineProvider
      withGlobalStyles
      withNormalizeCSS
      theme={{
        colorScheme: 'light',
        primaryColor: 'blue',
      }}
    >
      <Router>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <AppHeader links={navigationLinks} />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route
                path="/"
                element={user ? <Navigate to="/dashboard" /> : <Login />}
              />
              <Route
                path="/register"
                element={user ? <Navigate to="/dashboard" /> : <Register />}
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/bets"
                element={
                  <PrivateRoute>
                    <BetsList />
                  </PrivateRoute>
                }
              />
              <Route
                path="/upload"
                element={
                  <PrivateRoute>
                    <BetSlipUpload />
                  </PrivateRoute>
                }
              />
              <Route
                path="/review"
                element={
                  <PrivateRoute>
                    <BetSlipReview />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </MantineProvider>
  );
}
